import {
  IVitalListEmptyEntry,
  IVitalListEntry,
  TRecordConfig,
  TVitalDataResponse,
  TVitalDataSearchItem,
  TVitalSettingsResponse,
} from '../../../types/life-id';
import getGraphData from '../get-graph-data';
import { getDetailRowProps } from '../get-detail-row-props';
import getBadgeProps from '../get-badge-props';

/**
 *
 * @param vitalData
 * @param vitalDataSettings
 * @param config TRecordConfig
 */
export default function cholesterolEntry(
  vitalData: TVitalDataResponse | null,
  vitalDataSettings: TVitalSettingsResponse | null,
  config: TRecordConfig,
): IVitalListEntry | IVitalListEmptyEntry {
  const emptyEntry: IVitalListEmptyEntry = {
    isEmpty: true,
    iconSrc: require('../../../assets/svg/icon-cholesterol.svg').default,
    title: 'life_id.cholesterol',
  };

  if (!vitalDataSettings || !vitalData || !vitalData.cholesterol) {
    return emptyEntry;
  }

  const settings = [vitalDataSettings.cholesterol];
  const lastRecord = vitalData.cholesterol.lastRecord;

  return {
    ...emptyEntry,
    modalType: 'CHOLESTEROL' as const,
    isEmpty: false,
    average: vitalData.cholesterol.average || '-',
    status: `life_id:status.${lastRecord.status}`,
    ...getBadgeProps(lastRecord.source),
    getDetailRowProps: getDetailRowProps(
      settings,
      config.CHOLESTEROL.valueSelectors[0] as keyof TVitalDataSearchItem,
    ),
    summaryChartProps: {
      oneSidedRange: false,
      unit: `units.${config.CHOLESTEROL.unit}`,
      value: lastRecord.cholesterol || '-',
      ...getGraphData(settings, [lastRecord.cholesterol]),
    },
    urlPart: config.CHOLESTEROL.urlPart,
  };
}
